import { render, staticRenderFns } from "./OrderAnalyze.vue?vue&type=template&id=bc908328&scoped=true"
import script from "./OrderAnalyze.vue?vue&type=script&lang=js"
export * from "./OrderAnalyze.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=bc908328&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc908328",
  null
  
)

export default component.exports